/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Question = {
    properties: {
        id: {
    type: 'number',
},
        departmentId: {
    type: 'number',
},
        question: {
    type: 'string',
    isRequired: true,
},
        alertDepartment: {
    type: 'boolean',
    isRequired: true,
},
        allowComment: {
    type: 'boolean',
    isRequired: true,
},
        allowFeedback: {
    type: 'boolean',
    isRequired: true,
},
        order: {
    type: 'number',
},
        ratingScore: {
    type: 'boolean',
    isRequired: true,
},
    },
};